import { ToggleButton, ToggleButtonGroup } from '@src/shared/ui/Button';

type HoursToggleProps = {
  hours: boolean;
  onChange: (hours: boolean) => void;
  disabled?: boolean;
};

export default function HoursToggle({
  hours,
  onChange,
  disabled = false,
}: HoursToggleProps) {
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    hours: boolean,
  ) => onChange(hours);

  return (
    <ToggleButtonGroup
      color="primary"
      disabled={disabled}
      value={hours}
      exclusive
      onChange={handleChange}
      fullWidth
      sx={{ marginBottom: '20px' }}
    >
      <ToggleButton value={true}>Hours</ToggleButton>
      <ToggleButton value={false}>Days</ToggleButton>
    </ToggleButtonGroup>
  );
}
